/**
 * Violazione / Incidente — coreBOS `evDataBreaches` (96x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const dataBreachDescriptor = {
    slug: 'cmp_data_breach',
    kind: 'document',
    label: { singular: 'Violazione / Incidente', plural: 'Violazioni e Incidenti' },
    table: 'compliance_data_breach',
    idStrategy: 'sha256',
    fields: [
        { name: 'dbrtitle', type: 'text', label: 'Titolo', required: true },
        { name: 'dbrdatetime', type: 'datetime', label: 'Data Rilevamento' },
        { name: 'dbreactualdate', type: 'datetime', label: 'Data Effettiva' },
        { name: 'dbrmodality', type: 'text', label: 'Modalità' },
        { name: 'dbrstatus', type: 'text', label: 'Stato' },
        { name: 'dbrpriority', type: 'text', label: 'Priorità' },
        { name: 'bdrsource', type: 'text', label: 'Fonte' },
        { name: 'dbrcategory', type: 'text', label: 'Categoria' },
        { name: 'dbrnotify', type: 'text', label: 'Notifica' },
        { name: 'dbrnotificationdate', type: 'date', label: 'Data Notifica' },
        { name: 'dbrprotocolnumber', type: 'text', label: 'Numero Protocollo' },
        { name: 'dbrimmediateactions', type: 'text', label: 'Dbrimmediateactions' },
        { name: 'dbranalysisactions', type: 'text', label: 'Dbranalysisactions' },
        { name: 'dbrnotifyactions', type: 'text', label: 'Dbrnotifyactions' },
        { name: 'dbrcorrectiveactions', type: 'text', label: 'Dbrcorrectiveactions' },
        { name: 'dbrdatatype', type: 'text', label: 'Dbrdatatype' },
        { name: 'dbrcommunication', type: 'text', label: 'Dbrcommunication' },
        { name: 'dbrcomunicationdatesubjects', type: 'date', label: 'Dbrcomunicationdatesubjects' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
        { name: 'incident_type', type: 'text', label: 'Incident type' },
        { name: 'notification_deadline1', type: 'datetime', label: 'Notification deadline1' },
        { name: 'notification_deadline2', type: 'datetime', label: 'Notification deadline2' },
        { name: 'risk_to_individuals', type: 'text', label: 'Rischio per gli interessati' }, // pending coreBOS field (vtlib 10)
        { name: 'ai_act_report_date', type: 'date', label: 'Data segnalazione AI Act (Art. 73)' }, // pending coreBOS field (vtlib 10)
    ],
    relations: [
        { name: 'dbrlinktocontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'AlertOutlined', navGroup: 'GDPR', deadlines: [{ field: 'notification_deadline1', warnDays: [1, 3] }, { field: 'notification_deadline2', warnDays: [1, 3] }] },
};
